/**
 * PRIVATE-internal-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { MessageTag } from "../message-tag";
import { Message } from "./message";

/**
 * A {@link Message} designed for application-internal consumption only.
 */
export class InternalMessage extends Message
{
  /** The {@link Message} tag. */
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.PVT_INTERNAL;
  public static tag : MessageTag = MessageTag.PVT_INTERNAL;

  public timestamp : number = Date.now();

  public expectsReply () : boolean
  {
    return false;
  }

  // You can NEVER send a this because it's for internal consumption only
  public sendable () : boolean
  {
    return false;
  }

  public constructor (public content : string)
  {
    super();
  }
}

export enum ConnectionFailure
{
  NoResponse
}

export const ConnectionFailureContent = "Connection failed";

export class ConnectionFailureMessage extends InternalMessage
{
  constructor (
    public reason : ConnectionFailure, message : string = ConnectionFailureContent)
  {
    super(message);
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/general/PRIVATE-internal-message.ts